import script from "./SfxIssueAdditionalRequirements.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxIssueAdditionalRequirements.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
